export default __webpack_public_path__ + "static/20922-Menu-Manage-Console-c18b2fd2109332708e20fb129e57d03e.jpg";